var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "stadiafr-jeux-awards" } },
    [
      _vm.is_loading
        ? [_c("Loader")]
        : [
            _vm.error_message
              ? [
                  _c("div", {
                    staticClass: "item-error",
                    domProps: { innerHTML: _vm._s(_vm.error_message) }
                  })
                ]
              : [
                  _c("Header"),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.list_of_games, function(game) {
                    return _c(
                      "div",
                      {
                        staticClass: "item-game",
                        class: _vm.itemGameBindClass()
                      },
                      [
                        _c("div", { staticClass: "picture" }, [
                          _c("div", [
                            _c("img", { attrs: { src: game.picture_url } })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metadatas" }, [
                          _c("div", [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(game.title))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(1, true)
                      ]
                    )
                  })
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-title" }, [
      _c("div", [_vm._v("Votez pour vos jeux préférés de l'année 2020 !")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "results" }, [
      _c("div", [_c("div", [_vm._v("107")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }